import companies from './companies.reducer'
import urlParams from './urlParams.reducer'

const store = {
	urlParams,
	companies,
}

export default store
